import { useInstance } from 'intact-vue';
export function useShowHideEvents(prop, show, hide) {
  if (prop === void 0) {
    prop = 'value';
  }
  if (show === void 0) {
    show = 'show';
  }
  if (hide === void 0) {
    hide = 'hide';
  }
  var instance = useInstance();
  instance.watch(prop, function (value) {
    if (value) {
      instance.trigger(show);
    } else {
      instance.trigger(hide);
    }
  }, {
    presented: true
  });
}